@if (mode() === 'edit') {
    @let hasStipend = hasStipend$ | async;
    <div class="w-full grid grid-cols-4 gap-medpace items-center">
        <div class="col-span-2 col-start-1">
            <p>{{ displayName() }}</p>
            @if (existingStipend()) {
                <p class="text-lg text-color-subtext">
                    Updated by {{ modifierShortenedName$ | async }},
                    {{ existingStipend().modifiedTimestamp | dateFormat }}
                </p>
            }
        </div>
        <div class="text-center">
            <mds-checkbox id="hasStipend" [formCtrl]="formGrp().controls.hasStipend" name="stipend" />
        </div>
        <div class="text-center">
            <mds-text-field
                [class.hidden]="!hasStipend"
                id="VisitAmountToAuthorizeField"
                data-cy="VisitamountToAuthorizeField"
                [formCtrl]="formGrp().controls.amount"
                inputType="decimal"
                [decimalPlaces]="2"
                appearance="outline"
                [label]="undefined"
            />
            <!-- [label]="undefined" will remove the red asterisk -->
            <!-- the asterisk looks really bad, it pushes the input field to the next row -->
        </div>
    </div>
} @else if (mode() === 'view') {
    <div class="w-full grid grid-cols-4 gap-medpace items-center">
        <div class="col-span-2 col-start-1">
            <p>{{ displayName() }}</p>
            @if (existingStipend()) {
                <p class="text-lg text-color-subtext">
                    Updated by {{ modifierShortenedName$ | async }},
                    {{ existingStipend().modifiedTimestamp | dateFormat }}
                </p>
            }
        </div>
        <div class="text-center">
            <mds-checkbox id="hasStipend" [checked]="!!existingStipend()" [disabled]="true" name="stipend" />
        </div>
        @if (existingStipend()) {
            <div class="text-center">
                {{ existingStipend().amount | number: '1.2-2' : 'en-US' }}
            </div>
        }
    </div>
}
